import { render, staticRenderFns } from "./FrequencyDocumentDesktopEdit.vue?vue&type=template&id=79c48932"
import script from "./FrequencyDocumentDesktopEdit.vue?vue&type=script&lang=ts"
export * from "./FrequencyDocumentDesktopEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79c48932')) {
      api.createRecord('79c48932', component.options)
    } else {
      api.reload('79c48932', component.options)
    }
    module.hot.accept("./FrequencyDocumentDesktopEdit.vue?vue&type=template&id=79c48932", function () {
      api.rerender('79c48932', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/frequency-documents/FrequencyDocumentDesktopEdit.vue"
export default component.exports